import { createFileRoute, notFound } from "@tanstack/react-router";
import { NotFoundPage } from "@/components/not-found";

// Unknown URLs throw notFound() so the server responds with a real HTTP 404.
export const Route = createFileRoute("/$")({
  loader: () => {
    throw notFound();
  },
  component: NotFoundPage,
});
